module.exports = __webpack_public_path__ + "img/holiday02.7e2a54f8.png";